import React from 'react';

interface Props {
  hideLoader?: boolean;
}

export default class FsLoader extends React.Component<Props> {
  constructor(props: any) {
    super(props);
    // this.setAppCursorStyle();
  }

  // componentDidUpdate(prevProps: any) {
  //   const { hideLoader } = this.props;
  //   if (prevProps.hideLoader !== hideLoader) this.setAppCursorStyle();
  // }

  componentWillUnmount() {
    const root = document.getElementById('root');
    if (root) {
      root.style.cursor = 'default';
    }
  }

  setAppCursorStyle = () => {
    const { hideLoader = false } = this.props;
    const root = document.getElementById('root');
    if (root) {
      root.style.cursor = hideLoader ? 'default' : 'progress';
    }
  };

  render() {
    const { hideLoader = false } = this.props;
    return (
      <>
        {!hideLoader && (
          <div className="ajax-loader">
            <div className="ajax-animator"></div>
          </div>
        )}
      </>
    );
  }
}
